import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../services/api';
import { useVendor } from '../context/VendorContext';
import { offlineQueueCount } from '../utils/offlinePedidoQueue';

export default function Dashboard({ onNavigate, onOpenGuardados }) {
  const { appName, vendedor } = useVendor();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pendingOffline, setPendingOffline] = useState(() => offlineQueueCount(vendedor?.id));

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    setPendingOffline(offlineQueueCount(vendedor?.id));
    api
      .getDashboard()
      .then((r) => {
        setData(r.data || null);
        if (!r.data) setError('No se pudo cargar el resumen');
      })
      .catch((err) => {
        setData(null);
        setError(err.message || 'No se pudo cargar el resumen');
      })
      .finally(() => setLoading(false));
  }, [vendedor?.id]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const refresh = () => setPendingOffline(offlineQueueCount(vendedor?.id));
    window.addEventListener('online', refresh);
    const t = setInterval(refresh, 45000);
    return () => {
      window.removeEventListener('online', refresh);
      clearInterval(t);
    };
  }, [vendedor?.id]);

  if (loading) return <p className="loading-grid">Cargando resumen...</p>;

  if (error || !data) {
    return (
      <section className="page">
        <p className="empty-state">{error || 'No se pudo cargar el resumen'}</p>
        {pendingOffline > 0 ? (
          <p className="error banner" style={{ maxWidth: 420, margin: '0 auto 12px' }}>
            Hay {pendingOffline} pedido{pendingOffline === 1 ? '' : 's'} guardado
            {pendingOffline === 1 ? '' : 's'} en la tablet por enviar.
          </p>
        ) : null}
        <button type="button" className="btn-primary" onClick={load}>
          Reintentar
        </button>
        <button
          type="button"
          className="btn-secondary"
          style={{ marginLeft: 8 }}
          onClick={() => onNavigate('pedido')}
        >
          Ir al catálogo
        </button>
      </section>
    );
  }

  return (
    <section className="page">
      <div className="welcome-banner">
        <div>
          <p className="welcome-kicker">Bienvenida</p>
          <h1>{appName}</h1>
        </div>
        <button type="button" className="welcome-cta" onClick={() => onNavigate('pedido')}>
          Ver catálogo
        </button>
      </div>

      {pendingOffline > 0 ? (
        <p className="error banner">
          {pendingOffline} pedido{pendingOffline === 1 ? '' : 's'} guardado
          {pendingOffline === 1 ? '' : 's'} en tablet (cotización / confirmación). Envía a
          oficina cuando el cliente confirme — toca Guardados.
        </p>
      ) : null}

      <div className="stats-grid stats-grid-vendor">
        <div className="stat-card">
          <span>Pedidos hoy</span>
          <strong>{data.pedidos_hoy}</strong>
        </div>
        <div className="stat-card">
          <span>Pendientes</span>
          <strong>{data.pedidos_pendientes}</strong>
        </div>
        <button type="button" className="stat-card stat-card-link" onClick={() => onNavigate('mis-clientes')}>
          <span>Mis clientes</span>
          <strong>{data.clientes}</strong>
        </button>
      </div>

      <div className="quick-actions">
        <button type="button" className="btn-primary" onClick={() => onNavigate('pedido')}>
          + Nuevo pedido
        </button>
        <button type="button" className="btn-secondary" onClick={() => onNavigate('pedidos')}>
          Ver mis pedidos
        </button>
        <button type="button" className="btn-secondary" onClick={() => onNavigate('historial')}>
          Historial
        </button>
        <button
          type="button"
          className={`btn-secondary${pendingOffline > 0 ? ' btn-guardados-active' : ''}`}
          onClick={() => onOpenGuardados?.()}
        >
          Guardados{pendingOffline > 0 ? ` (${pendingOffline})` : ''}
        </button>
      </div>

      <h2 className="section-title">Últimos pedidos</h2>
      <div className="pedidos-list">
        {(data.ultimos_pedidos || []).map((p) => (
          <button
            key={p.id}
            type="button"
            className="pedido-card"
            onClick={() => onNavigate('pedido-detalle', { id: p.id })}
          >
            <div className="pedido-card-top">
              <strong>{p.numero}</strong>
            </div>
            <div className="pedido-card-body">
              <span>{p.cliente_nombre}</span>
            </div>
            <div className="pedido-card-footer">
              <span>{new Date(p.created_at).toLocaleString('es-CO')}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
